








import {Component, Vue} from 'vue-property-decorator';
import ContentPage from "@/components/ContentPage.vue";

@Component({
  components: {
    ContentPage,
  }
})
export default class Page404 extends Vue {
  isLoading = true;

  async created() {
    this.isLoading = false;
  }
}
